import { useId } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Typography } from '@mui/material';

import { REPORTS } from '../tokens';

export function WelcomeBanner({ onDismiss }: { onDismiss: () => void }) {
  const titleId = useId();
  return (
    <Box
      component="section"
      aria-labelledby={titleId}
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '24px',
        padding: '24px',
        borderRadius: '12px',
        bgcolor: REPORTS.welcome.bg,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', flexGrow: 1, minWidth: 0 }}>
        <Typography
          id={titleId}
          component="h2"
          sx={{ fontSize: 20, lineHeight: '28px', fontWeight: 600, color: REPORTS.ink }}
        >
          Welcome to Reports
        </Typography>
        <Typography
          sx={{ maxWidth: 720, fontSize: 16, lineHeight: '24px', fontWeight: 500, color: REPORTS.muted }}
        >
          Your Flashlight360 data, turned into reports that show where students are today, how
          they are growing, and where to focus support next. Start by printing student progress
          reports below.
        </Typography>
      </Box>
      <IconButton
        aria-label="Dismiss welcome message"
        onClick={onDismiss}
        sx={{ flexShrink: 0, width: 40, height: 40, margin: '-8px', color: REPORTS.welcome.dismiss }}
      >
        <CloseIcon sx={{ fontSize: 24 }} />
      </IconButton>
    </Box>
  );
}
